module.exports = __webpack_public_path__ + "static/klrc-0a6de3c663b58a737ba0b928a9717a82.jpg";